export default __webpack_public_path__ + "static/media/koristi-podatoci.2de36342.gif";